import React from "react";
import "../../stylez/HoursWorkedList.css";
import CoachHoursCard from "./CoachHoursCard";
import { sumEventsHours } from "../../functions/calculateHours";
function AllHoursCardList({ events }) {
  return (
    <div className="hours-worked-cards-list">
      {events &&
        Object.entries(events).map(([coachName, coachEvents]) => {
          const hours = sumEventsHours(coachEvents);
          const count = Array.isArray(coachEvents) ? coachEvents.length : 0;
          return (
            <CoachHoursCard
              key={coachName}
              coachName={coachName}
              hours={hours}
              eventCount={count}
            />
          );
        })}
    </div>
  );
}

export default AllHoursCardList;
